import { render, staticRenderFns } from "./PlanUpgrade.vue?vue&type=template&id=265afd8a&scoped=true&"
import script from "./PlanUpgrade.vue?vue&type=script&lang=js&"
export * from "./PlanUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265afd8a",
  null
  
)

export default component.exports